{
  "app": {
    "name": "SignMeOut",
    "tagline": "Every child, handed over or home — confirmed."
  },
  "nav": {
    "main": "Main",
    "dismissal": "Dismissal",
    "students": "Students",
    "users": "Users",
    "messages": "Messages",
    "reports": "Reports",
    "audit": "Activity log",
    "settings": "Settings",
    "today": "Today",
    "people": "Pickup people",
    "changes": "Changes",
    "history": "History",
    "account": "Account",
    "more": "More",
    "peopleShort": "People"
  },
  "common": {
    "loading": "Loading…",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "remove": "Remove",
    "close": "Close",
    "clear": "Clear",
    "more": "More actions",
    "choose": "Choose…",
    "listSep": ", ",
    "back": "Back"
  },
  "auth": {
    "lede": "Sign in to manage school pickup and dismissal.",
    "withPhone": "Phone",
    "withEmail": "Email",
    "email": "Email",
    "password": "Password",
    "phone": "Mobile number",
    "phoneHint": "International format, for example +971 50 123 4567",
    "code": "6-digit code",
    "codeSent": "We sent a code by SMS if this number is registered with the school.",
    "sendCode": "Send code",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "chooseSchool": "Which school?",
    "chooseHint": "You have accounts at more than one school.",
    "aboutPlatform": "About {{name}}"
  },
  "status": {
    "waiting": "Waiting",
    "guardian_arrived": "At the gate",
    "released": "Picked up",
    "departed": "Walking home",
    "home_confirmed": "Home",
    "absent": "Absent"
  },
  "mode": {
    "pickup": "Adult pickup",
    "independent": "Goes home alone"
  },
  "changeKind": {
    "alternate_pickup": "Someone else picks up",
    "absent": "Absent",
    "independent": "Goes home alone",
    "pickup": "Will be picked up"
  },
  "via": {
    "link": "link",
    "sms": "SMS reply",
    "guardian": "guardian",
    "staff": "staff"
  },
  "role": {
    "admin": "Administrator",
    "staff": "Staff",
    "guardian": "Guardian"
  },
  "days": {
    "0": "Sun",
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat"
  },
  "board": {
    "dismissalAt": "Dismissal at {{time}}.",
    "live": "Live",
    "reconnecting": "Reconnecting",
    "notOpen": "Dismissal has not started.",
    "pickDate": "Show another day",
    "open": "Start dismissal",
    "reopen": "Reopen dismissal",
    "opened": "Dismissal started",
    "scan": "Scan pickup pass",
    "remaining": "of {{total}} still to go",
    "atGateCount": "at the gate",
    "walkingCount": "walking home",
    "alerts": "Alerts",
    "alertsTitle_one": "{{count}} child needs attention",
    "alertsTitle_other": "{{count}} children need attention",
    "resolve": "Mark handled",
    "resolveTitle": "Mark alert as handled",
    "resolveNote": "What happened?",
    "resolved": "Alert marked as handled",
    "emptyToday": "Start dismissal to load today's students. It also starts automatically before dismissal time on school days.",
    "emptyPast": "There was no dismissal on this day.",
    "atGate": "At the gate",
    "gateEmpty": "When a parent taps “I'm here”, their children appear here.",
    "arrivedBy": "{{name}} arrived {{minutes}} min ago",
    "grade": "Grade {{grade}}",
    "release": "Release",
    "releaseToAdult": "Release to an adult instead",
    "releasedToast": "{{name}} released",
    "releasedTo": "Picked up by {{name}} at {{time}}",
    "leftAt": "Left at {{time}}",
    "homeAt": "Home at {{time}} ({{via}})",
    "students": "Students",
    "filter": {
      "active": "Still here",
      "waiting": "Waiting",
      "walking": "Walking home",
      "done": "Done",
      "absent": "Absent",
      "all": "All"
    },
    "search": "Search by name",
    "gradeFilter": "Filter by grade",
    "allGrades": "All grades",
    "selected_one": "{{count}} selected",
    "selected_other": "{{count}} selected",
    "departSelected": "Let selected leave",
    "noneHere": "No students match this view.",
    "depart": "Let leave",
    "departed": "{{name}} left school",
    "markHome": "Mark home",
    "markedHome": "{{name}} marked home",
    "markAbsent": "Mark absent",
    "markedAbsent": "{{name}} marked absent",
    "undo": "Undo",
    "undoTitle": "Undo the last step",
    "undoReason": "Why are you undoing this?",
    "undone": "Moved back to waiting",
    "arrivedJustNow": "{{name}} arrived just now",
    "departDone_one": "{{count}} student left school",
    "departDone_other": "{{count}} students left school",
    "departPartial": "{{done}} left school; {{failed}} could not leave (already picked up or changed). The list is refreshed.",
    "close": "Close dismissal",
    "closeConfirm": "Close today's dismissal? Children still waiting stay on the list and their alerts continue.",
    "closed": "Dismissal closed",
    "closedBadge": "Closed",
    "scanShort": "Scan pass"
  },
  "alert": {
    "unclaimed": "Not collected yet. Guardians were sent an SMS.",
    "unclaimedEmergency": "Still not collected. Emergency contacts were sent an SMS. Call the family.",
    "notDeparted": "Should walk home but hasn't been marked as leaving.",
    "home": "Left {{minutes}} min ago, no arrival confirmation yet.",
    "homeFinal": "Still no arrival confirmation after {{minutes}} min.",
    "arrivedNotReleased": "An authorized adult is at the gate but the child hasn't been released.",
    "unclaimedNoGuardian": "Not collected, and no guardian with a phone is on file, so nobody was texted. Call the office contacts.",
    "unclaimedNoEmergency": "Still not collected. There is no emergency contact with a phone to text. Call the family now."
  },
  "release": {
    "title": "Release {{name}}",
    "who": "Who is collecting? Compare their face with the photo.",
    "todayOnly": "Today only",
    "noPhoto": "No photo on file. Check ID.",
    "notListed": "The adult isn't on the list",
    "overrideHelp": "Only release after confirming with a guardian by phone. This is recorded in the activity log.",
    "overrideName": "Adult's full name",
    "overrideReason": "How was it confirmed?",
    "overridePlaceholder": "Called mother at 14:10, she confirmed",
    "confirm": "Release to {{name}}",
    "confirmOverride": "Release to {{name}} (recorded)"
  },
  "scan": {
    "title": "Scan pickup pass",
    "code": "Pass code",
    "find": "Find",
    "useCamera": "Use camera",
    "stopCamera": "Stop camera",
    "checkFace": "Check that this is the person in front of you.",
    "noPhoto": "No photo on file. Check ID before releasing.",
    "noChildren": "This person isn't allowed to collect any child today."
  },
  "today": {
    "dismissal": "Dismissal is at {{time}}. Same-day changes close at {{cutoff}}.",
    "imHere": "I'm here",
    "imHereFor": "Tell the gate you're here for {{names}}",
    "arrivedToast": "The gate knows you're here",
    "noChildren": "No children are linked to your account yet. Please contact the school office.",
    "notStarted": "Not started",
    "confirmHome": "{{name}} is home",
    "confirmedToast": "Arrival confirmed",
    "changeToday": "Change today",
    "passTitle": "Your pickup pass",
    "passHelp": "Show this code at the gate. Staff scan it and see your photo.",
    "showPass": "Show pass",
    "hidePass": "Hide pass",
    "notOpenYet": "Today's dismissal hasn't started yet.",
    "planChange": "Plan a change",
    "line": {
      "arrived": "You arrived at {{time}}",
      "released": "Picked up by {{name}} at {{time}}",
      "departed": "Left school at {{time}}",
      "home": "Arrived home at {{time}}",
      "arrivedOther": "{{name}} arrived at {{time}}"
    },
    "closed": "Today's dismissal has been closed by the school."
  },
  "people": {
    "title": "Pickup people",
    "lede": "Only the people listed here can collect your children. Add a clear face photo for each one.",
    "add": "Add a person",
    "edit": "Edit person",
    "empty": "Nobody is listed yet.",
    "you": "you",
    "emergency": "Emergency contact",
    "needsPhoto": "Add a photo so staff can recognise them.",
    "addPhoto": "Add photo",
    "changePhoto": "Change photo",
    "photoSaved": "Photo saved",
    "pass": "Pickup pass",
    "passFor": "Pickup pass for {{name}}",
    "passShare": "Send a screenshot of this pass to them. They show it at the gate.",
    "removeConfirm": "Remove {{name}}? They will no longer be able to collect your children.",
    "removed": "Person removed",
    "fullName": "Full name",
    "relationship": "Relationship",
    "relationshipHint": "For example grandmother, driver, neighbour",
    "phone": "Mobile number",
    "forWhich": "Allowed to collect",
    "emergencyHelp": "Emergency contact: message them if nobody has collected the child"
  },
  "changes": {
    "title": "Changes",
    "lede": "Tell the school about a different plan for a day. Same-day changes must be made before {{cutoff}}; after that, call the office.",
    "which": "For",
    "date": "Date",
    "what": "What changes",
    "who": "Who will collect",
    "whoHint": "Add new people on the Pickup people page first.",
    "note": "Note for staff (optional)",
    "submit": "Save change",
    "saved": "Change saved",
    "upcoming": "Upcoming changes",
    "none": "No changes planned.",
    "cancel": "Cancel change",
    "cancelled": "Change cancelled",
    "cancelConfirm": "Cancel this change?"
  },
  "history": {
    "title": "History",
    "empty": "No dismissals in the last 60 days.",
    "date": "Date",
    "child": "Child",
    "status": "Outcome",
    "details": "Details",
    "homeAt": "home at {{time}}",
    "leftUnconfirmed": "Left (arrival not confirmed)"
  },
  "confirm": {
    "question": "Is {{name}} home?",
    "leftAt": "Left school at {{time}}.",
    "button": "Yes, home safe",
    "done": "{{name}} is home",
    "doneAt": "Confirmed at {{time}}. The family has been told.",
    "invalid": "This link isn't valid any more.",
    "notApplicable": "There's nothing to confirm right now."
  },
  "students": {
    "title": "Students",
    "count_one": "{{count}} student",
    "count_other": "{{count}} students",
    "add": "Add student",
    "edit": "Edit student",
    "import": "Import CSV",
    "search": "Search by name or ID",
    "showInactive": "Show inactive",
    "empty": "No students found.",
    "name": "Name",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "externalId": "School ID",
    "grade": "Grade",
    "homeroom": "Class",
    "mode": "Usually",
    "guardians": "Guardians",
    "authorized": "Pickup people",
    "phone": "Student mobile",
    "phoneHint": "Used for the “I'm home” SMS",
    "window": "Minutes to get home",
    "windowHint": "Leave empty to use the school default",
    "notes": "Notes for gate staff",
    "notesHint": "For example: custody arrangement on file, see office",
    "active": "Enrolled (uncheck when the student leaves)",
    "inactive": "Inactive",
    "back": "All students",
    "recordChange": "Record a change",
    "changeHelp": "Use this when a guardian calls after the cutoff. It's recorded with your name.",
    "changeSource": "How did the guardian tell you?",
    "changeSourcePh": "Mother called at 12:30",
    "addGuardian": "Add guardian",
    "guardianHelp": "The guardian signs in with this mobile number and gets SMS updates.",
    "noGuardians": "No guardian linked. This child can't be released through the app.",
    "unlink": "Unlink",
    "unlinkConfirm": "Unlink {{name}} from this student?",
    "pickupPeople": "Who can collect",
    "newCode": "New pass code",
    "newCodeConfirm": "Issue a new pass code? The current pass stops working immediately.",
    "newCodeDone": "New pass code issued"
  },
  "users": {
    "title": "Users",
    "add": "Add user",
    "edit": "Edit user",
    "search": "Search by name, email or phone",
    "allRoles": "All roles",
    "role": "Role",
    "contact": "Contact",
    "lastLogin": "Last sign-in",
    "never": "Never",
    "language": "Language",
    "newPassword": "New password",
    "passwordHint": "At least 10 characters. Staff and admins need one; guardians can sign in by SMS code.",
    "active": "Can sign in"
  },
  "messages": {
    "title": "Messages",
    "lede": "Every SMS the system sent or tried to send.",
    "filter": "Filter by status",
    "all": "All messages",
    "empty": "No messages yet.",
    "status": {
      "queued": "Sending",
      "sent": "Sent",
      "failed": "Failed"
    },
    "retry": "Try again",
    "retried": "Queued again"
  },
  "reports": {
    "title": "Reports",
    "lede": "How dismissal is going, day by day.",
    "lastDays_one": "Last day",
    "lastDays_other": "Last {{count}} days",
    "empty": "No dismissals in this period.",
    "avgPickup": "Average wait after dismissal",
    "avgPickupShort": "Avg. wait (min)",
    "minutes": "{{value}} min",
    "escalations": "Escalations",
    "overrides": "Off-list releases",
    "changes": "Changes",
    "students": "Students",
    "unresolved": "Unresolved"
  },
  "audit": {
    "title": "Activity log",
    "lede": "Who did what, and when. Entries can't be edited or deleted.",
    "all": "All activity",
    "when": "When",
    "who": "Who",
    "action": "Action",
    "details": "Details",
    "system": "System",
    "more": "Load older",
    "filter": {
      "dismissal": "Dismissal",
      "escalation": "Alerts and reminders",
      "auth": "Sign-ins",
      "authorization": "Pickup people",
      "change": "Changes",
      "guardian": "Guardians",
      "person": "People",
      "user": "Users",
      "student": "Students",
      "school": "Settings",
      "import": "Imports",
      "notification": "Texts"
    }
  },
  "settings": {
    "title": "Settings",
    "saved": "Settings saved",
    "school": "School",
    "nameEn": "School name (English)",
    "nameAr": "School name (Arabic)",
    "timezone": "Time zone",
    "timezoneHint": "For example Asia/Dubai or Asia/Riyadh",
    "defaultLocale": "SMS language for contacts without an account",
    "defaultLocaleHint": "Guardians get messages in the language they chose",
    "dismissal": "Dismissal",
    "schoolDays": "School days",
    "dismissalTime": "Dismissal time",
    "autoOpen": "Start dismissal automatically (minutes before)",
    "autoOpenHint": "Set 0 to start it exactly at dismissal time",
    "cutoff": "Same-day change cutoff",
    "cutoffHint": "After this time guardians must call the office",
    "unclaimed": "Alert after (minutes)",
    "unclaimedHint": "If a child isn't collected this long after dismissal, guardians get an SMS. Emergency contacts get one after twice this time.",
    "homeWindow": "Time to get home (minutes)",
    "homeWindowHint": "Default for students who go home alone",
    "alertStaff": "Also alert staff when a student hasn't confirmed arriving home",
    "alertStaffHint": "Off by default: the school's responsibility ends when the student leaves. Check with your administration before turning this on.",
    "logo": "School logo",
    "logoHint": "Shown on your sign-in page and at the top of the app. A square PNG or JPEG works best.",
    "uploadLogo": "Upload logo",
    "removeLogo": "Remove logo",
    "logoSaved": "Logo updated",
    "subscription": "Subscription",
    "plan": "Plan",
    "address": "Your web address",
    "studentsUsage": "{{n}} of {{max}} students",
    "studentsUsageNoMax": "{{n}} students",
    "smsUsage": "{{n}} texts sent this month ({{included}} included)",
    "smsUsageNoMax": "{{n}} texts sent this month",
    "trialEnds": "Free trial until {{date}}",
    "trialEnded": "Your free trial has ended. Contact us to continue.",
    "demoNote": "This is a demo school. Nothing here is billed.",
    "welcomeTitle": "Welcome page and colour",
    "welcomeHint": "Families see this on your school’s address before signing in. Leave the message empty for our standard text.",
    "welcomeEn": "Welcome message (English)",
    "welcomeAr": "Welcome message (Arabic)",
    "brandColor": "School colour",
    "brandColorHint": "Used for the top bar and highlights. Text switches to dark or light automatically so it stays readable.",
    "brandDefault": "Default",
    "brandReset": "Use default",
    "welcomePage": "Your welcome page",
    "welcomeOpen": "Open it in a new tab"
  },
  "import": {
    "title": "Import students and guardians",
    "lede": "Upload a CSV with one row per student and guardian. Repeat a student on a second row to add another guardian. Existing students (same School ID) are updated.",
    "template": "Download template",
    "chooseFile": "Choose CSV file",
    "check": "Check file",
    "run": "Import",
    "checked": "Check complete: {{rows}} rows, {{studentsCreated}} new students, {{studentsUpdated}} updates, {{guardiansLinked}} guardian links. Nothing has been saved yet.",
    "done": "Imported: {{studentsCreated}} new students, {{studentsUpdated}} updated, {{guardiansLinked}} guardian links.",
    "rowError": "Row {{row}}: {{error}}"
  },
  "account": {
    "title": "Account",
    "languageHint": "Used for the app and the SMS you receive",
    "password": "Password",
    "current": "Current password",
    "changePassword": "Change password",
    "passwordChanged": "Password changed",
    "sessions": "Signed-in devices",
    "sessionsHelp": "Sign out everywhere if you lost a phone or used a shared computer.",
    "signOutAll": "Sign out on all devices"
  },
  "errors": {
    "generic": "Something went wrong. Try again.",
    "invalid_credentials": "Email or password is incorrect.",
    "invalid_code": "That code is wrong or has expired. Request a new one.",
    "unauthenticated": "Your session ended. Sign in again.",
    "forbidden": "You don't have permission to do that.",
    "not_authorized": "This person isn't authorized to collect this child today.",
    "csrf": "Reload the page and try again.",
    "not_found": "We couldn't find that. It may have been removed.",
    "validation": "Some details are missing or invalid.",
    "past_cutoff": "It's past the cutoff for same-day changes. Please call the school office.",
    "past_date": "That date is in the past.",
    "nothing_to_collect": "None of your children are waiting for pickup right now.",
    "session_closed": "Today's dismissal is closed.",
    "invalid_state": "This was already updated by someone else. The list has been refreshed.",
    "not_independent": "This student must be released to an authorized adult.",
    "override_required": "Enter the adult's name and how you confirmed it.",
    "person_required": "Choose who will collect.",
    "duplicate": "Someone with this email or phone already exists.",
    "wrong_password": "Current password is incorrect.",
    "self_lockout": "You can't deactivate or demote your own account.",
    "contact_required": "Add an email or a mobile number.",
    "staff_credentials": "Staff and administrators need an email and a password.",
    "guardian_details": "Name and mobile number are required.",
    "invalid_image": "Use a JPEG, PNG or WebP photo.",
    "empty_csv": "The file has no rows.",
    "no_file": "Choose a file first.",
    "FST_ERR_RATE_LIMIT": "Too many attempts. Wait a minute and try again.",
    "invalid_phone": "Enter the mobile number in international format, for example +971 50 123 4567.",
    "invalid_timezone": "That time zone isn't recognised. Use a name like Asia/Dubai.",
    "rate_limited": "Too many attempts. Wait a few minutes and try again.",
    "duplicate_student_id": "Another student already has this school ID.",
    "csv_semicolon": "The file uses semicolons. In Excel, save it as \"CSV UTF-8 (comma delimited)\" and try again.",
    "school_suspended": "This school’s account is paused. Please contact the school.",
    "invalid_ticket": "Please sign in again.",
    "demo_busy": "The demo is very busy right now. Try again in a few minutes.",
    "slug_taken": "That web address is already used by another school.",
    "domain_taken": "That domain is already used by another school.",
    "confirm_mismatch": "Type the school’s web address exactly to confirm.",
    "duplicate_user": "Someone at this school already uses that email or phone.",
    "duplicate_email": "That email is already on the team.",
    "cannot_remove_self": "You can’t remove yourself.",
    "demo_limit": "The demo accepts files of up to 100 rows.",
    "cannot_remove_owner": "The platform owner can’t be removed."
  },
  "relation": {
    "mother": "mother",
    "father": "father",
    "parent": "parent",
    "guardian": "guardian",
    "grandmother": "grandmother",
    "grandfather": "grandfather",
    "aunt": "aunt",
    "uncle": "uncle",
    "brother": "brother",
    "sister": "sister",
    "sibling": "sibling",
    "driver": "driver",
    "nanny": "nanny",
    "babysitter": "babysitter",
    "neighbour": "neighbour",
    "neighbor": "neighbor",
    "family": "family",
    "family friend": "family friend",
    "stepmother": "stepmother",
    "stepfather": "stepfather"
  },
  "demo": {
    "title": "Try it as…",
    "lede": "You get your own sandbox school with six students and today’s dismissal already open. Switch roles whenever you like. No texts go to real phones, and the sandbox is deleted after {{hours}} hours.",
    "guardian": "A parent",
    "guardianText": "Tap “I’m here”, choose who may collect, plan a one-off change.",
    "staff": "Gate staff",
    "staffText": "See who’s at the gate, compare photos, release children.",
    "admin": "The school office",
    "adminText": "Students, users, texts sent, reports and settings.",
    "start": "Start as {{role}}",
    "starting": "Setting up your school…",
    "bar": "Live demo",
    "viewAs": "View as",
    "endsAt": "Deleted at {{time}}",
    "getIt": "Get it for your school",
    "back": "Back"
  },
  "setup": {
    "title": "Set your password",
    "welcome": "Welcome, {{name}}",
    "forSchool": "Your account at {{school}}.",
    "password": "New password",
    "hint": "At least 10 characters.",
    "repeat": "Repeat password",
    "mismatch": "The passwords don’t match.",
    "save": "Set password and sign in",
    "invalid": "This link has expired or was already used. Ask whoever sent it for a new one.",
    "doneSuspended": "Password set. Sign-in opens when the school’s account is active again."
  },
  "unavailable": {
    "notFoundTitle": "There’s no school at this address",
    "notFoundText": "Check the address you were given.",
    "suspendedTitle": "{{school}} is paused",
    "suspendedText": "Sign-in is turned off for now. Families and staff: please contact the school office. School administrators: please contact {{name}}.",
    "home": "Go to {{name}}"
  },
  "landing": {
    "nav": {
      "how": "How it works",
      "pricing": "Pricing",
      "faq": "Questions",
      "signIn": "Sign in",
      "demo": "Try the demo",
      "menu": "Menu"
    },
    "hero": {
      "title": "Every child leaves school with the right adult, or tells you they got home.",
      "lede": "Parents tap “I’m here” and the gate sees their children with photos of everyone allowed to collect them. Older students confirm they’re home with one text. When something doesn’t happen on time, the right people hear about it.",
      "demo": "Try the live demo",
      "book": "Book a call",
      "note": "No sign-up. You get your own sandbox school in a second."
    },
    "board": {
      "title": "Gate board",
      "live": "Live",
      "dismissal": "Dismissal 14:00",
      "waiting": "Waiting",
      "atGate": "{{name}} is at the gate",
      "handed": "Handed to {{name}} at {{time}}",
      "walking": "Walking home",
      "home": "Home at {{time}}",
      "reminded": "Parents texted",
      "kid0": "Noa Haddad",
      "kid1": "Adam Haddad",
      "kid2": "Daniel Haddad",
      "kid3": "Layla Al-Khatib",
      "kid4": "Yousef Al-Khatib",
      "kid5": "Mira Saleh",
      "adult0": "Sara",
      "adult1": "Ruth",
      "adult2": "Khalid",
      "grade0": "KG2",
      "grade1": "Grade 3",
      "grade2": "Grade 8",
      "grade3": "Grade 1",
      "grade4": "Grade 10",
      "grade5": "KG2"
    },
    "journeys": {
      "title": "Two ways home. Both confirmed.",
      "pickup": "Picked up",
      "walk": "Walks home",
      "p1": "The parent taps “I’m here” on their phone as they reach the gate.",
      "p2": "Their children appear on the gate staff’s screen, next to photos of everyone allowed to collect them.",
      "p3": "Staff check the face or scan the parent’s pass, and release the child. The parent gets a text.",
      "w1": "Staff let older students leave with one tap, a whole class at a time.",
      "w2": "Each student gets a text with a link. They tap it, or reply 1, when they’re home.",
      "w3": "No reply in time? A reminder goes out, then their parents are told."
    },
    "timeline": {
      "title": "When a child isn’t collected",
      "lede": "Follow-up runs on its own, so nobody at the gate has to remember to chase.",
      "t0": "Dismissal",
      "t0Text": "Children appear on the gate board. Parents can tap “I’m here”.",
      "t15": "+15 minutes",
      "t15Text": "Parents get a text: your child is still waiting at school.",
      "t30": "+30 minutes",
      "t30Text": "Emergency contacts are texted and the office sees an alert.",
      "tEnd": "Handover",
      "tEndText": "The release is recorded: which adult, which staff member, what time."
    },
    "roles": {
      "title": "One system for everyone at the gate",
      "parents": "Parents",
      "parentsText": "Sign in with a code by text. Choose who may collect, add their photos, and plan changes like “Grandma on Thursday”.",
      "staff": "Gate staff",
      "staffText": "The whole dismissal on one screen, on a phone or tablet. Compare faces before releasing, record phone calls, see alerts.",
      "office": "School office",
      "officeText": "Import students from a spreadsheet, manage accounts, read every text sent, and keep an activity log nobody can edit."
    },
    "trust": {
      "title": "Built for schools",
      "arabic": "Arabic and English throughout: right-to-left screens, and texts in each family’s language.",
      "photos": "Photos are only visible to signed-in staff and the child’s own family.",
      "audit": "Every release, override and change goes into an activity log that can’t be edited.",
      "own": "Your school’s own address, logo and SMS sender name.",
      "phones": "Works in any phone browser, and installs to the home screen. No app store needed."
    },
    "pricing": {
      "title": "Pricing",
      "lede": "One price per school per year, by number of students. Every plan includes every feature.",
      "plan": "Plan",
      "students": "Students",
      "upTo": "Up to {{n}}",
      "anyNumber": "Any number",
      "perYear": "Per year",
      "custom": "Let’s talk",
      "sms": "Texts included per month",
      "smsCustom": "Custom",
      "extras": "Also included",
      "setup": "One-time setup {{amount}}: we import your students and train your gate staff.",
      "overage": "Texts beyond the monthly allowance are {{amount}} each.",
      "trial": "Every school starts with a {{days}}-day free trial.",
      "choose": "Book a call",
      "features": {
        "all_features": "Every feature",
        "email_support": "Email support",
        "priority_support": "Priority support",
        "own_logo": "Your logo",
        "own_domain": "Your own domain",
        "sender_id": "Your SMS sender name",
        "dedicated": "Dedicated hosting option",
        "account_manager": "Account manager"
      }
    },
    "faq": {
      "title": "Questions schools ask",
      "q1": "Do parents need to install an app?",
      "a1": "No. It works in the phone’s browser and can be added to the home screen like an app. Parents sign in with a code sent by text.",
      "q2": "What if a parent doesn’t have a smartphone?",
      "a2": "Staff can release a child to anyone on the authorized list, and record changes phoned in to the office. The texts work on any phone.",
      "q3": "Who can see our data?",
      "a3": "Only your school’s staff, and each family sees only their own children. Every school’s data is kept separate, and photos are never public.",
      "q4": "Can we use our own domain and logo?",
      "a4": "Yes. Each school gets its own address with us, and can also use its own domain, logo and SMS sender name.",
      "q5": "How long does it take to start?",
      "a5": "Usually a day or two. Send us your student list as a spreadsheet; we import it and train your gate staff."
    },
    "contact": {
      "title": "Book a call",
      "lede": "Tell us about your school. We reply within one working day.",
      "name": "Your name",
      "email": "Work email",
      "phone": "Phone (optional)",
      "school": "School",
      "students": "Number of students",
      "message": "Anything we should know? (optional)",
      "send": "Send request",
      "sent": "Thanks. We’ll be in touch within one working day."
    },
    "footer": {
      "schoolSignIn": "School sign-in",
      "console": "Control panel",
      "rights": "© {{year}} {{name}}"
    }
  },
  "platform": {
    "title": "Control panel",
    "signIn": "Sign in to the control panel",
    "lede": "For the {{name}} team.",
    "nav": {
      "schools": "Schools",
      "leads": "Demo requests",
      "team": "Team"
    },
    "kpi": {
      "schools": "Schools",
      "active": "Paying",
      "trial": "On trial",
      "suspended": "Paused",
      "students": "Students",
      "sms": "Texts this month",
      "arr": "Yearly revenue",
      "leads": "New requests",
      "demos": "Live demos"
    },
    "status": {
      "trial": "Trial",
      "active": "Active",
      "suspended": "Paused"
    },
    "col": {
      "school": "School",
      "plan": "Plan",
      "status": "Status",
      "students": "Students",
      "sms": "Texts this month",
      "lastActive": "Last active"
    },
    "search": "Search schools",
    "addSchool": "Add school",
    "noSchools": "No schools yet. Add the first one.",
    "never": "Never",
    "overLimit": "Over plan limit",
    "trialEnded": "Trial ended",
    "smsOver": "{{n}} over allowance",
    "form": {
      "profile": "School",
      "name": "Name (English)",
      "nameAr": "Name (Arabic)",
      "slug": "Web address",
      "slugTaken": "Already taken",
      "timezone": "Time zone",
      "locale": "Default language",
      "dismissal": "Dismissal time",
      "billing": "Plan and billing",
      "plan": "Plan",
      "startAs": "Start as",
      "trialDays": "Trial length (days)",
      "trialEndsAt": "Trial ends",
      "status": "Status",
      "branding": "Address and SMS",
      "customDomain": "School’s own domain (optional)",
      "customDomainHint": "e.g. pickup.myschool.org. The school adds a CNAME record pointing to {{target}}.",
      "smsSender": "SMS sender name (optional)",
      "smsSenderHint": "A registered sender ID such as ALNOOR, or a number. Leave empty to use ours.",
      "contact": "Billing contact",
      "contactName": "Name",
      "contactEmail": "Email",
      "contactPhone": "Phone",
      "notes": "Private notes",
      "notesHint": "Only your team sees these.",
      "admin": "First school admin",
      "adminHint": "They get a link to set their password.",
      "adminName": "Full name",
      "adminEmail": "Email",
      "adminPhone": "Mobile (optional)",
      "create": "Create school",
      "save": "Save changes",
      "saved": "Saved"
    },
    "link": {
      "title": "Sign-in link for {{name}}",
      "text": "Send this link to {{name}}. It lets them set a password and sign in. It works once and expires on {{date}}.",
      "copy": "Copy link",
      "copied": "Link copied",
      "copyFailed": "Couldn’t copy. Select the link and copy it."
    },
    "detail": {
      "usage": "Usage",
      "smsChart": "Texts sent per month",
      "admins": "School admins",
      "addAdmin": "Add admin",
      "newLink": "New sign-in link",
      "hasPassword": "Has a password",
      "noPassword": "Hasn’t set a password",
      "visit": "Open school",
      "activity": "Changes by your team",
      "danger": "Pause or delete",
      "suspend": "Pause school",
      "resume": "Resume school",
      "suspendText": "Pausing signs everyone at the school out, stops automatic dismissals and texts, and blocks sign-in until you resume.",
      "delete": "Delete school",
      "deleteText": "Deletes the school with all its students, accounts, photos and history. This can’t be undone. Type {{slug}} to confirm.",
      "deleted": "School deleted",
      "planPrice": "{{amount}} per year",
      "planCustom": "Custom price",
      "back": "All schools",
      "staffAccounts": "Staff accounts",
      "parentAccounts": "Parent accounts",
      "suspendConfirm": "Pause {{school}}? Everyone there is signed out until you resume."
    },
    "leads": {
      "title": "Demo requests",
      "empty": "No requests yet. They arrive from the form on the landing page.",
      "students": "{{n}} students",
      "status": {
        "new": "New",
        "contacted": "Contacted",
        "won": "Won",
        "lost": "Lost"
      },
      "createSchool": "Create school"
    },
    "team": {
      "title": "Team",
      "add": "Add team member",
      "name": "Full name",
      "email": "Email",
      "password": "Temporary password",
      "remove": "Remove",
      "removed": "Removed",
      "added": "Added",
      "you": "you",
      "inactive": "Removed",
      "audit": "Activity log",
      "myAccount": "My account",
      "current": "Current password",
      "new": "New password",
      "changePassword": "Change password",
      "passwordChanged": "Password changed",
      "removeConfirm": "Remove {{name}} from the team?",
      "owner": "Owner"
    }
  },
  "actions": {
    "auth_login": "Signed in",
    "auth_password_changed": "Changed password",
    "auth_password_set": "Set password from link",
    "authorization_create": "Added pickup person",
    "authorization_revoke": "Removed pickup person",
    "authorization_update": "Updated pickup person",
    "change_cancel": "Cancelled a change",
    "change_create": "Planned a change",
    "dismissal_absent": "Marked absent",
    "dismissal_alert_resolved": "Resolved an alert",
    "dismissal_arrived": "Arrived at the gate",
    "dismissal_auto_open": "Dismissal opened automatically",
    "dismissal_close": "Closed dismissal",
    "dismissal_depart": "Let leave",
    "dismissal_home_confirmed": "Confirmed home",
    "dismissal_open": "Started dismissal",
    "dismissal_release": "Released",
    "dismissal_release_override": "Released to someone not on the list",
    "dismissal_undo": "Undid a release",
    "guardian_link": "Linked guardian",
    "guardian_unlink": "Unlinked guardian",
    "import_csv": "Imported a file",
    "notification_retry": "Retried a text",
    "person_photo": "Updated a photo",
    "person_regenerate_code": "New pickup pass",
    "student_create": "Added student",
    "student_photo": "Updated student photo",
    "student_update": "Updated student",
    "user_create": "Added user",
    "user_update": "Updated user",
    "school_update": "Changed settings",
    "school_logo": "Uploaded logo",
    "school_logo_removed": "Removed logo",
    "school_created": "School created",
    "school_updated": "School updated",
    "school_suspended": "School paused",
    "school_status_changed": "School status changed",
    "school_deleted": "School deleted",
    "school_admin_added": "Admin added",
    "school_setup_link": "Sign-in link created",
    "lead_status": "Demo request updated",
    "team_added": "Team member added",
    "team_removed": "Team member removed",
    "demo_started": "Demo started"
  },
  "welcome": {
    "title": "Welcome to {{school}}",
    "defaultMessage": "Pickup and dismissal at {{school}} happen in this app. Tap “I’m here” when you reach the gate, and staff get your children ready. You get a text the moment they’re handed over.",
    "installCta": "Add to your phone",
    "howTitle": "How pickup works",
    "step1": "Sign in with your mobile number. We text you a code; there’s no password to remember.",
    "step2": "Choose who may collect your children, and add a photo of each person.",
    "step3": "At dismissal, tap “I’m here” as you reach the gate. Staff check the face, hand over your children, and you get a text.",
    "walkers": "Older students who walk home confirm with one text when they arrive. If they don’t, you’re told.",
    "installTitle": "Add it to your phone",
    "installLede": "It works like an app, with the school’s icon on your home screen. No app store needed.",
    "installNow": "Install the app",
    "iphone": "Open this page in Safari, tap the Share button, then “Add to Home Screen”.",
    "android": "Open this page in Chrome, tap ⋮, then “Install app” (or “Add to Home screen”).",
    "poweredBy": "Powered by {{name}}",
    "back": "‹ {{school}}"
  }
}
